<template>
    <v-bottom-navigation v-model="value">
      <v-btn value="recent" icon>
        <span>Recent</span>

        <v-icon>mdi-history</v-icon>
      </v-btn>

      <v-btn value="favorites" icon>
        <span>Favorites</span>

        <v-icon>mdi-heart</v-icon>
      </v-btn>

      <v-btn value="nearby" icon to="/about">
        <span>About</span>

        <v-icon>mdi-information</v-icon>
      </v-btn>
    </v-bottom-navigation>
</template>

<script>
export default ({
  name: 'AppFooter',
  data: () => ({
    value: 'recent'
  })
})
</script>
